import Icon from '../components/Icon.vue'

Icon.register({
  'cloud-meatball': {
    width: 512,
    height: 512,
    paths: [
      {
        d: 'M48 352c26.5 0 48 21.5 48 48s-21.5 48-48 48-48-21.5-48-48 21.5-48 48-48zM464 352c26.5 0 48 21.5 48 48s-21.5 48-48 48-48-21.5-48-48 21.5-48 48-48zM345 363.1c13.5 7 23 20.7 23 36.9s-9.5 29.9-23 36.9c4.6 14.5 1.7 30.8-9.8 42.3-8.2 8.2-18.9 12.3-29.7 12.3-4.3 0-8.5-1.2-12.6-2.5-7 13.5-20.7 23-36.9 23s-29.9-9.5-36.9-23c-4.1 1.4-8.3 2.5-12.6 2.5-10.8 0-21.5-4.1-29.7-12.3-11.5-11.5-14.5-27.8-9.9-42.3-13.5-7-23-20.7-23-36.9s9.5-29.9 23-36.9c-4.5-14.5-1.6-30.8 9.9-42.3s27.8-14.5 42.3-9.9c7-13.5 20.7-23 36.9-23s29.9 9.5 36.9 23c14.5-4.5 30.8-1.6 42.3 9.9 11.4 11.5 14.4 27.8 9.8 42.3zM512 224c0 53-43 96-96 96h-43.4c-3.5-8-8.4-15.4-14.8-21.8-13.5-13.5-31.5-21.1-50.8-21.3-13.5-13.2-31.7-20.9-51-20.9s-37.5 7.7-51 20.9c-19.3 0.2-37.3 7.8-50.8 21.3-6.4 6.4-11.2 13.8-14.8 21.8h-43.4c-53 0-96-43-96-96 0-42.5 27.8-78.2 66.1-90.8-1.3-6.9-2.1-13.9-2.1-21.2 0-61.9 50.1-112 112-112 43.3 0 80.4 24.8 99 60.8 14.7-17.5 36.4-28.8 61-28.8 44.2 0 80 35.8 80 80 0 5.6-0.5 11-1.6 16.2 0.5 0 1-0.2 1.6-0.2 53 0 96 43 96 96z'
      }
    ]
  }
})
